module.exports = __webpack_public_path__ + "img/1-5.7f26aed8.webp";